export default __webpack_public_path__ + "static/media/green-tick.319dd2a1.svg";